import { combineReducers } from 'redux';

import * as types from 'modules/checklists/actionTypes';
import type { ApiError } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import page, { initialState as initialPageState } from 'modules/global/reducers/generic.page';
import { isSuccessRequest } from 'modules/global/reducers/utils';

import ids, { mainDashboardConfig } from './ids';

const dashboard = combineReducers({
  ids,
  page: page(types.SEARCH_CHECKLISTS_REQUEST, {
    reducers: { [types.CLEAN_CHECKLISTS]: () => initialPageState },
    global: mainDashboardConfig,
  }),
  apiError: error<ApiError>(types.SEARCH_CHECKLISTS_REQUEST, {
    matchers: [{ matcher: isSuccessRequest(types.SEARCH_CHECKLISTS_REQUEST, mainDashboardConfig), reducer: () => null }],
    global: mainDashboardConfig,
  }),
  isFetching: loading(types.SEARCH_CHECKLISTS_REQUEST, {
    reducers: { [types.CLEAN_CHECKLISTS]: () => false },
    global: mainDashboardConfig,
  }),
});

export type ChecklistUiDashboardReducer = ReturnType<typeof dashboard>;

export default dashboard;
